var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 484,
    viewBox: "0 0 460 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.373 333.095C312.477 333.095 313.373 332.2 313.373 331.095C313.373 329.991 312.477 329.095 311.373 329.095C310.268 329.095 309.373 329.991 309.373 331.095C309.373 332.2 310.268 333.095 311.373 333.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 191C370.105 191 371 190.105 371 189C371 187.895 370.105 187 369 187C367.895 187 367 187.895 367 189C367 190.105 367.895 191 369 191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 320C37.1046 320 38 319.105 38 318C38 316.895 37.1046 316 36 316C34.8954 316 34 316.895 34 318C34 319.105 34.8954 320 36 320Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 280C94.1046 280 95 279.105 95 278C95 276.895 94.1046 276 93 276C91.8954 276 91 276.895 91 278C91 279.105 91.8954 280 93 280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 268C17.1046 268 18 267.105 18 266C18 264.895 17.1046 264 16 264C14.8954 264 14 264.895 14 266C14 267.105 14.8954 268 16 268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 283C348.105 283 349 282.105 349 281C349 279.895 348.105 279 347 279C345.895 279 345 279.895 345 281C345 282.105 345.895 283 347 283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 278C426.105 278 427 277.105 427 276C427 274.895 426.105 274 425 274C423.895 274 423 274.895 423 276C423 277.105 423.895 278 425 278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 325C406.105 325 407 324.105 407 323C407 321.895 406.105 321 405 321C403.895 321 403 321.895 403 323C403 324.105 403.895 325 405 325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 363C79.1046 363 80 362.105 80 361C80 359.895 79.1046 359 78 359C76.8954 359 76 359.895 76 361C76 362.105 76.8954 363 78 363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 411C148.105 411 149 410.105 149 409C149 407.895 148.105 407 147 407C145.895 407 145 407.895 145 409C145 410.105 145.895 411 147 411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 437C101.105 437 102 436.105 102 435C102 433.895 101.105 433 100 433C98.8954 433 98 433.895 98 435C98 436.105 98.8954 437 100 437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 454C182.105 454 183 453.105 183 452C183 450.895 182.105 450 181 450C179.895 450 179 450.895 179 452C179 453.105 179.895 454 181 454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 396C339.105 396 340 395.105 340 394C340 392.895 339.105 392 338 392C336.895 392 336 392.895 336 394C336 395.105 336.895 396 338 396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 292C459.105 292 460 291.105 460 290C460 288.895 459.105 288 458 288C456.895 288 456 288.895 456 290C456 291.105 456.895 292 458 292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 351C438.105 351 439 350.105 439 349C439 347.895 438.105 347 437 347C435.895 347 435 347.895 435 349C435 350.105 435.895 351 437 351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 335C124.105 335 125 334.105 125 333C125 331.895 124.105 331 123 331C121.895 331 121 331.895 121 333C121 334.105 121.895 335 123 335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 210C120.105 210 121 209.105 121 208C121 206.895 120.105 206 119 206C117.895 206 117 206.895 117 208C117 209.105 117.895 210 119 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 216C54.1046 216 55 215.105 55 214C55 212.895 54.1046 212 53 212C51.8954 212 51 212.895 51 214C51 215.105 51.8954 216 53 216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 109C144.105 109 145 108.105 145 107C145 105.895 144.105 105 143 105C141.895 105 141 105.895 141 107C141 108.105 141.895 109 143 109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 127C94.1046 127 95 126.105 95 125C95 123.895 94.1046 123 93 123C91.8954 123 91 123.895 91 125C91 126.105 91.8954 127 93 127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 66C111.105 66 112 65.1046 112 64C112 62.8954 111.105 62 110 62C108.895 62 108 62.8954 108 64C108 65.1046 108.895 66 110 66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 96C77.1046 96 78 95.1046 78 94C78 92.8954 77.1046 92 76 92C74.8954 92 74 92.8954 74 94C74 95.1046 74.8954 96 76 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 128C49.1046 128 50 127.105 50 126C50 124.895 49.1046 124 48 124C46.8954 124 46 124.895 46 126C46 127.105 46.8954 128 48 128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 160C3.10457 160 4 159.105 4 158C4 156.895 3.10457 156 2 156C0.89543 156 0 156.895 0 158C0 159.105 0.89543 160 2 160Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 32C105.105 32 106 31.1046 106 30C106 28.8954 105.105 28 104 28C102.895 28 102 28.8954 102 30C102 31.1046 102.895 32 104 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 9C169.105 9 170 8.10457 170 7C170 5.89543 169.105 5 168 5C166.895 5 166 5.89543 166 7C166 8.10457 166.895 9 168 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 4C270.105 4 271 3.10457 271 2C271 0.89543 270.105 0 269 0C267.895 0 267 0.89543 267 2C267 3.10457 267.895 4 269 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 48C272.105 48 273 47.1046 273 46C273 44.8954 272.105 44 271 44C269.895 44 269 44.8954 269 46C269 47.1046 269.895 48 271 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 52C325.105 52 326 51.1046 326 50C326 48.8954 325.105 48 324 48C322.895 48 322 48.8954 322 50C322 51.1046 322.895 52 324 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 83C325.105 83 326 82.1046 326 81C326 79.8954 325.105 79 324 79C322.895 79 322 79.8954 322 81C322 82.1046 322.895 83 324 83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 104C417.105 104 418 103.105 418 102C418 100.895 417.105 100 416 100C414.895 100 414 100.895 414 102C414 103.105 414.895 104 416 104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 137C393.105 137 394 136.105 394 135C394 133.895 393.105 133 392 133C390.895 133 390 133.895 390 135C390 136.105 390.895 137 392 137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 120C310.105 120 311 119.105 311 118C311 116.895 310.105 116 309 116C307.895 116 307 116.895 307 118C307 119.105 307.895 120 309 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 52C362.105 52 363 51.1046 363 50C363 48.8954 362.105 48 361 48C359.895 48 359 48.8954 359 50C359 51.1046 359.895 52 361 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 52C362.105 52 363 51.1046 363 50C363 48.8954 362.105 48 361 48C359.895 48 359 48.8954 359 50C359 51.1046 359.895 52 361 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 400C291.105 400 292 399.105 292 398C292 396.895 291.105 396 290 396C288.895 396 288 396.895 288 398C288 399.105 288.895 400 290 400Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 433C374.105 433 375 432.105 375 431C375 429.895 374.105 429 373 429C371.895 429 371 429.895 371 431C371 432.105 371.895 433 373 433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 450C291.105 450 292 449.105 292 448C292 446.895 291.105 446 290 446C288.895 446 288 446.895 288 448C288 449.105 288.895 450 290 450Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 473C335.105 473 336 472.105 336 471C336 469.895 335.105 469 334 469C332.895 469 332 469.895 332 471C332 472.105 332.895 473 334 473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 380C366.105 380 367 379.105 367 378C367 376.895 366.105 376 365 376C363.895 376 363 376.895 363 378C363 379.105 363.895 380 365 380Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 303C312.105 303 313 302.105 313 301C313 299.895 312.105 299 311 299C309.895 299 309 299.895 309 301C309 302.105 309.895 303 311 303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 256C318.105 256 319 255.105 319 254C319 252.895 318.105 252 317 252C315.895 252 315 252.895 315 254C315 255.105 315.895 256 317 256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 253C402.105 253 403 252.105 403 251C403 249.895 402.105 249 401 249C399.895 249 399 249.895 399 251C399 252.105 399.895 253 401 253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 228C453.105 228 454 227.105 454 226C454 224.895 453.105 224 452 224C450.895 224 450 224.895 450 226C450 227.105 450.895 228 452 228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 210C331.105 210 332 209.105 332 208C332 206.895 331.105 206 330 206C328.895 206 328 206.895 328 208C328 209.105 328.895 210 330 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 191C370.105 191 371 190.105 371 189C371 187.895 370.105 187 369 187C367.895 187 367 187.895 367 189C367 190.105 367.895 191 369 191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 164C366.105 164 367 163.105 367 162C367 160.895 366.105 160 365 160C363.895 160 363 160.895 363 162C363 163.105 363.895 164 365 164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 180C311.105 180 312 179.105 312 178C312 176.895 311.105 176 310 176C308.895 176 308 176.895 308 178C308 179.105 308.895 180 310 180Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 166C401.105 166 402 165.105 402 164C402 162.895 401.105 162 400 162C398.895 162 398 162.895 398 164C398 165.105 398.895 166 400 166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 156C77.1046 156 78 155.105 78 154C78 152.895 77.1046 152 76 152C74.8954 152 74 152.895 74 154C74 155.105 74.8954 156 76 156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 205C11.1046 205 12 204.105 12 203C12 201.895 11.1046 201 10 201C8.89543 201 8 201.895 8 203C8 204.105 8.89543 205 10 205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 218C90.1046 218 91 217.105 91 216C91 214.895 90.1046 214 89 214C87.8954 214 87 214.895 87 216C87 217.105 87.8954 218 89 218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 166C401.105 166 402 165.105 402 164C402 162.895 401.105 162 400 162C398.895 162 398 162.895 398 164C398 165.105 398.895 166 400 166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.373 131.095C448.477 131.095 449.373 130.2 449.373 129.095C449.373 127.991 448.477 127.095 447.373 127.095C446.268 127.095 445.373 127.991 445.373 129.095C445.373 130.2 446.268 131.095 447.373 131.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 89C290.209 89 292 87.2091 292 85C292 82.7909 290.209 81 288 81C285.791 81 284 82.7909 284 85C284 87.2091 285.791 89 288 89Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.373 82.0953C236.464 82.0953 254.373 64.1867 254.373 42.0953C254.373 20.0039 236.464 2.09532 214.373 2.09532C192.281 2.09532 174.373 20.0039 174.373 42.0953C174.373 64.1867 192.281 82.0953 214.373 82.0953Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.373 85.0953C230.464 85.0953 248.373 67.1867 248.373 45.0953C248.373 23.0039 230.464 5.09532 208.373 5.09532C186.281 5.09532 168.373 23.0039 168.373 45.0953C168.373 67.1867 186.281 85.0953 208.373 85.0953Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.372 483.04L214.88 483.039V482.565C214.88 478.695 216.418 474.983 219.154 472.247C221.891 469.51 225.603 467.972 229.473 467.972L236.322 462.777L249.1 467.973L252.373 467.973L252.372 483.04Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.919 462.791L202.886 482.274L202.64 481.869C200.629 478.562 200.014 474.592 200.93 470.832C201.846 467.071 204.218 463.829 207.524 461.817L210.676 453.819L224.293 451.618L227.089 449.918L234.919 462.791Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.943 356.565C256.773 357.765 256.523 361.845 256.233 367.785C254.823 396.585 252.373 469.095 252.373 469.095L237.103 464.345C237.103 464.345 218.943 409.565 221.943 379.565L219.783 369.125L216.083 351.285V351.275L204.813 296.945C204.813 296.945 202.343 311.665 202.143 315.115C201.943 318.565 199.943 319.565 198.943 319.565C193.933 319.565 195.473 318.675 196.203 323.625C196.733 327.185 192.393 347.595 189.913 358.755C188.953 363.095 188.273 366.035 188.273 366.035L192.513 375.175L227.663 450.975L214.373 458.095L161.353 379.515L156.123 371.765L155.003 363.075L146.183 294.705C146.183 294.705 143.433 286.975 146.183 286.775C148.943 286.565 150.503 287.435 149.723 284.505C148.943 281.565 164.943 232.565 164.943 232.565L247.943 250.565C247.943 250.565 256.123 266.825 252.943 274.565C249.753 282.305 255.553 342.245 252.243 344.906C248.943 347.565 246.813 345.435 251.373 350.005C252.07 350.733 252.894 351.329 253.803 351.765C256.623 353.045 257.743 350.965 256.943 356.565Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.113 70.0156C220.846 70.0156 231.168 59.6932 231.168 46.9599C231.168 34.2266 220.846 23.9042 208.113 23.9042C195.379 23.9042 185.057 34.2266 185.057 46.9599C185.057 59.6932 195.379 70.0156 208.113 70.0156Z",
    fill: "#DBAAB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.08 66.8162L216.94 68.5662C216.94 68.5662 225.44 54.8462 224.94 48.5662C224.44 42.2862 217.6 40.0362 217.6 40.0362C217.6 40.0362 213.81 40.8562 209.82 41.3162C209.342 39.9707 208.721 38.6801 207.97 37.4662C207.822 39.0333 207.128 40.4985 206.01 41.6062C204.547 41.7318 203.075 41.5618 201.68 41.1062C200.1 40.3862 200.13 39.1362 200.65 37.9662C195.5 38.3912 190.474 39.7714 185.83 42.0362C185.6 38.9661 185.717 35.8799 186.18 32.8362C186.4 32.7762 186.62 32.7063 186.84 32.6362C188.202 32.205 189.516 31.6319 190.76 30.9262C189.376 30.7426 188.083 30.1347 187.06 29.1862C187.9 26.7262 189.24 24.5962 191.35 23.5562C193.385 22.5606 195.611 22.0141 197.877 21.9537C200.142 21.8933 202.394 22.3205 204.48 23.2062C204.48 23.2062 199.59 19.6362 201.39 18.1762C201.51 18.2962 201.63 18.4062 201.76 18.5162C201.93 18.6562 202.12 18.8062 202.3 18.9462C203.41 19.8462 205.07 18.5762 205.29 17.2162C205.313 17.0445 205.347 16.8742 205.39 16.7062C205.42 16.5662 205.46 16.4262 205.5 16.2962C205.534 16.1808 205.574 16.0673 205.62 15.9562C208.95 15.1562 219.02 18.4062 222.89 25.5662C222.89 25.5662 249.94 38.5662 226.08 66.8162Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.728 272.376C217.394 270.073 217.973 267.731 219.34 265.848C220.707 263.964 222.755 262.689 225.048 262.293C225.516 262.22 225.989 262.185 226.462 262.19L250.569 206.208L267.106 218.624L234.908 271.658C234.736 273.618 233.92 275.466 232.587 276.914C231.255 278.362 229.481 279.328 227.541 279.661C226.436 279.84 225.307 279.799 224.217 279.542C223.127 279.284 222.099 278.815 221.191 278.16C220.283 277.505 219.513 276.678 218.924 275.725C218.336 274.772 217.941 273.713 217.762 272.608C217.75 272.531 217.738 272.454 217.728 272.376Z",
    fill: "#226FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.197 276.94C151.819 275.271 152.726 273.035 152.725 270.708C152.724 268.381 151.815 266.146 150.191 264.479C149.856 264.145 149.493 263.84 149.108 263.566L162.462 204.095L141.786 204.436L136.712 266.271C135.7 267.959 135.275 269.934 135.504 271.888C135.733 273.842 136.602 275.666 137.976 277.074C138.765 277.868 139.703 278.499 140.737 278.93C141.77 279.361 142.878 279.585 143.998 279.588C145.117 279.591 146.227 279.373 147.262 278.948C148.298 278.522 149.239 277.896 150.033 277.107C150.088 277.052 150.143 276.996 150.197 276.94Z",
    fill: "#226FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.443 177.385C280.443 181.385 276.443 176.875 280.443 182.635C283.193 186.595 267.433 223.715 257.343 246.455C252.783 256.745 249.373 264.095 249.373 264.095L232.363 254.245L230.373 253.095C230.373 253.095 245.973 213.835 250.993 199.725C251.823 197.385 252.373 195.735 252.503 195.075C253.443 190.385 253.563 186.365 252.503 184.875C252.252 184.32 252.038 183.749 251.863 183.165C249.853 177.275 243.733 157.385 238.003 138.575C236.333 133.055 234.683 127.635 233.183 122.685C229.333 109.975 226.443 100.385 226.443 100.385L249.443 101.385C249.443 101.385 249.823 102.025 250.493 103.185C252.093 105.945 255.373 111.635 259.173 118.475C261.913 123.395 264.933 128.925 267.783 134.365C275.043 148.205 281.293 161.535 279.443 163.385C275.443 167.385 271.353 165.115 276.393 170.245C281.443 175.385 286.443 173.385 283.443 177.385Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.94 230.566C249.94 224.626 251.05 197.556 251.05 197.556C251.05 197.556 257.02 106.656 248.94 100.566C243.353 96.5339 237.408 93.0225 231.18 90.0762C230.82 89.9162 230.63 89.8262 230.63 89.8262L225.47 75.2762L193.68 73.6262L188.13 84.4062C188.13 84.4062 187.26 84.4662 185.9 84.6562C180.82 85.3562 168.88 87.8362 169.94 95.5662C171.28 105.366 161.82 165.556 158.94 168.566C156.06 171.576 156.82 182.576 163.94 189.566C171.06 196.556 165.94 215.566 160.94 223.566C157.939 228.463 156.554 234.179 156.98 239.906C156.98 239.906 160.94 261.566 170.94 254.566C174.75 251.896 180.16 251.556 186.67 252.046C186.733 252.051 186.802 252.059 186.866 252.064L186.67 253.046C195.71 253.716 206.88 255.986 218.83 255.856L218.476 254.852C218.595 254.851 218.711 254.858 218.83 254.856C220.85 254.836 222.88 254.746 224.94 254.566C242.76 253.016 250.63 257.916 252.94 252.566C255.25 247.216 261.94 236.506 255.94 230.566Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209 74C225.569 74 239 60.5685 239 44C239 27.4315 225.569 14 209 14C192.431 14 179 27.4315 179 44C179 60.5685 192.431 74 209 74Z",
    fill: "#226FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.943 90.3853C193.943 90.3853 189.383 105.525 184.073 122.995C182.403 128.495 180.653 134.225 178.953 139.795C173.403 157.905 168.343 174.225 167.873 174.875C166.813 176.365 166.943 180.385 167.873 185.075C168.063 186.015 167.633 189.675 166.823 194.925C165.763 201.815 164.053 211.435 162.233 221.255C160.783 229.105 159.263 237.075 157.953 243.865C155.903 254.405 154.373 262.095 154.373 262.095H135.373C135.373 262.095 138.943 182.385 142.943 176.635C146.943 170.875 142.943 175.385 139.943 171.385C136.943 167.385 141.943 169.385 146.983 164.245C152.023 159.115 147.943 161.385 143.943 157.385C142.463 155.905 145.773 146.475 150.533 135.185C152.753 129.945 155.283 124.295 157.783 118.855C162.953 107.625 168.023 97.2955 170.033 93.2155C170.033 93.2055 170.043 93.1955 170.043 93.1855L170.943 91.3854L193.943 90.3853Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.373 94.0953C214.494 102.205 195.722 103.603 180.373 94.0953V76.0953C198.45 86.9417 216.79 86.6452 235.373 76.0953V94.0953Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.373 209.095C219.105 217.205 190.094 218.603 166.373 209.095V191.095C194.31 201.942 222.654 201.645 251.373 191.095V209.095Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.943 356.565C256.773 357.765 256.523 361.845 256.233 367.785C244.185 369.737 231.942 370.188 219.783 369.125L216.083 351.285C228.54 353.56 241.292 353.722 253.803 351.765C256.623 353.045 257.743 350.965 256.943 356.565Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.513 375.175C182.26 377.457 171.839 378.908 161.353 379.515L156.123 371.765L155.003 363.075C166.79 363.379 178.556 361.923 189.913 358.755C188.953 363.095 188.273 366.035 188.273 366.035L192.513 375.175Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.373 132.095C195.373 134.747 194.319 137.291 192.444 139.166C190.568 141.042 188.025 142.095 185.373 142.095C182.721 142.095 180.177 141.042 178.302 139.166C176.426 137.291 175.373 134.747 175.373 132.095C175.373 126.572 184.373 115.095 185.373 122.095C186.373 129.095 195.373 126.572 195.373 132.095Z",
    fill: "#226FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46 115.14C186.1 115.11 185.74 115.1 185.37 115.1C181.017 115.105 176.831 116.778 173.673 119.774C170.515 122.771 168.624 126.863 168.39 131.21C168.38 131.5 168.37 131.8 168.37 132.1C168.37 132.51 168.38 132.91 168.42 133.31C168.671 136.87 170.038 140.26 172.325 142.999C174.612 145.739 177.703 147.688 181.161 148.572C184.618 149.455 188.266 149.227 191.587 147.92C194.907 146.613 197.732 144.293 199.66 141.29C200.047 140.697 200.395 140.079 200.7 139.44C201.902 136.933 202.471 134.168 202.355 131.39C202.24 128.612 201.445 125.904 200.039 123.505C198.633 121.106 196.659 119.089 194.292 117.63C191.924 116.172 189.235 115.317 186.46 115.14ZM198.2 141C196.632 142.886 194.672 144.409 192.456 145.462C190.241 146.515 187.823 147.074 185.37 147.1C181.717 147.095 178.192 145.759 175.453 143.342C172.714 140.925 170.95 137.593 170.49 133.97C170.41 133.35 170.369 132.725 170.37 132.1C170.368 132.013 170.372 131.926 170.38 131.84C170.449 127.909 172.058 124.162 174.861 121.405C177.665 118.648 181.438 117.103 185.37 117.1C185.46 117.34 185.55 117.57 185.65 117.79C189.92 127.89 199.18 127.13 200.37 132.1C200.946 134.503 200.596 137.034 199.39 139.19C199.051 139.829 198.653 140.435 198.2 141Z",
    fill: "#226FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3_120",
    x: 0,
    y: 0,
    width: 460,
    height: 477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3_120",
    x: 135.373,
    y: 2.09532,
    width: 148.975,
    height: 484.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_120"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.7cdcd9fc985b8eb0c61829fd039c0489.svg";
export { ForwardRef as ReactComponent };